import { appendQueryStringToUrl } from 'shared/helpers/utils/url';
import { History } from 'history';
import checkValidHost from '@nykaa/server/utils';
import { pushEvent } from 'shared/helpers/utils/dataLayer';
import { pages } from 'shared/constants/urls';
import { REDIRECT_PARAM, MANDATORY_PARAM } from 'shared/User/constants/mobileVerification/url';
import { setCookie, getCookie, deleteCookie } from 'shared/helpers/utils/cookie';
import { REDIRECT_COOKIE, MANDATE_KEY } from 'shared/User/constants/mobileVerification';

export const getMobileVerifyStepFromHistory = (history: History): number => {
  let step = 0;
  if (history?.location?.state) {
    const { mobileVerifyStep } = history.location.state;

    if (mobileVerifyStep) {
      step = mobileVerifyStep;
    }
  }
  return step;
};

export const navigateUsersToMyProfilePage = () => {
  window.location.href = pages.MY_PROFILE_PAGE;
};

export const getRedirectUrl = (whiteListedDomains: string[] = []) => {
  const queryParams = new URLSearchParams(location.search);
  let sanitizedURI = '';
  const redirectURI = queryParams.get(REDIRECT_PARAM) || '';
  try {
    // if we are getting complete url in query param so picking it path only so that
    // it do not redirect to other site
    const url = new URL(redirectURI);
    sanitizedURI = `${url.pathname}${url.search}` || '';
  } catch (e) {
    // this means only path was passed in query param not a valid complete url
    if (!(redirectURI.indexOf('http') >= 0) && !(redirectURI.indexOf('//') === 0)) {
      sanitizedURI = redirectURI;
    }
  }
  return checkValidHost(sanitizedURI, whiteListedDomains);
};

export const navigateUserBack = () => {
  window.parent?.document?.getElementById('mobmapping_frame')?.remove();
  const redirectURI = getCookie(REDIRECT_COOKIE);
  if (redirectURI) {
    deleteCookie(REDIRECT_COOKIE);
    sessionStorage.removeItem(MANDATE_KEY);
    window.location.href = redirectURI;
  } else {
    navigateUsersToMyProfilePage();
  }
};

export const exitMobileVerificationFlow = () => {
  window.parent?.document?.getElementById('mobmapping_frame')?.remove();
  // temporary
  setTimeout(() => {
    const redirectURI = getCookie(REDIRECT_COOKIE);
    deleteCookie(REDIRECT_COOKIE);
    sessionStorage.removeItem(MANDATE_KEY);
    window.location.href = appendQueryStringToUrl(redirectURI || pages.MY_PROFILE_PAGE, 'root=mobile_mapping_close');
  }, 200);
};

export const increaseMobileVerifyStepInHistory = (history: History): void => {
  const mobileVerifyStep = getMobileVerifyStepFromHistory(history);

  history.push({
    state: {
      mobileVerifyStep: mobileVerifyStep + 1,
    },
  });
};

interface PushMobileVerificationEvents {
  actionName: string; // can be converted to an enum
  data: any;
}

export const pushMobileVerificationEvents = ({ actionName, data }: PushMobileVerificationEvents) => {
  pushEvent(actionName, {
    mobileVerification: {
      action: actionName,
      data,
    },
  });
};

const isMandatoryParam = () => {
  const queryParams = new URLSearchParams(location.search);
  return !!(queryParams.get(MANDATORY_PARAM) || '');
};

export const storeRedirectUrl = (whiteListedDomains: string[]) => {
  const redirectURI = getRedirectUrl(whiteListedDomains);
  if (redirectURI) {
    deleteCookie(REDIRECT_COOKIE);
    setCookie(REDIRECT_COOKIE, redirectURI, 1);
  }
  if (isMandatoryParam()) {
    sessionStorage.setItem(MANDATE_KEY, '1');
  }
};

export const isMandatoryMapping = () => !!sessionStorage.getItem(MANDATE_KEY);
